import React from 'react'
import { router } from '@inertiajs/react'
import Layout from '../Layout'
import DataTable from '../../../Components/DataTable'
import Button from '../../../Components/Button'
import ResourceIndexHeader from '../../../Components/ResourceIndexHeader'
import { useDeleteWithConfirmation } from '../../../hooks/useDeleteWithConfirmation'

export default function Index({
  account,
  accounts,
  navigation,
  venues,
  is_admin
}) {
  const handleDelete = useDeleteWithConfirmation('/manage/venues')

  const columns = [
    {
      key: 'name',
      label: 'Name',
      sortable: true,
      render: (value, item) => (
        <div className="flex items-center">
          {item.image_url && (
            <img
              src={item.image_url}
              alt={item.name}
              className="h-10 w-10 rounded-lg object-cover mr-3"
            />
          )}
          <div>
            <div className="font-medium text-gray-900">{value}</div>
            {item.description && (
              <div className="text-gray-500 truncate max-w-xs">{item.description}</div>
            )}
          </div>
        </div>
      )
    },
    {
      key: 'capacity',
      label: 'Capacity',
      sortable: true,
      render: (value) => value || '–'
    },
    {
      key: 'package_count',
      label: 'Packages',
      className: 'text-gray-500'
    },
    {
      key: 'active',
      label: 'Status',
      render: (value) => (
        <span className={`inline-flex rounded-full px-2 py-1 text-xs font-semibold ${
          value ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'
        }`}>
          {value ? 'Active' : 'Inactive'}
        </span>
      )
    }
  ]

  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="Venues"
      is_admin={is_admin}
    >
      <ResourceIndexHeader
        count={venues.length}
        singular="venue"
        plural="venues"
        addHref="/manage/venues/new"
        addLabel="Add Venue"
      />

      <DataTable
        data={venues}
        columns={columns}
        actions={(item) => (
          <>
            <Button link href={`/manage/venues/${item.id}/edit`}>Edit</Button>
            <Button link variant="danger" onClick={() => handleDelete(item)}>Delete</Button>
          </>
        )}
        searchable={true}
        searchPlaceholder="Search venues..."
        emptyState={{
          message: 'No venues found',
          action: { label: 'Add your first venue', href: '/manage/venues/new' }
        }}
        baseUrl="/manage/venues"
      />
    </Layout>
  )
}
